import { UserGroupTypes } from '../enum/user-groups.enum'

export interface UserGroupFilters {
  name?: string
  id?: number
  usersId?: number[]
  dealerId?: number
  groupId?: number
  type?: UserGroupTypes
}